import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { PutPolicyFailure, PutPolicyRequest, PutPolicySuccess } from './actions';
import { HomePolicy } from '@models/swagger';
import { PutPolicyService } from './service';

@Injectable()
export class PutPolicyEffects {
  private readonly actions$ = inject(Actions);
  private readonly putPolicyService = inject(PutPolicyService);

  putPolicy$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PutPolicyRequest),
      switchMap(({ body, parameters }) =>
        this.putPolicyService.putPolicy(body, parameters).pipe(
          map((data: HomePolicy) => PutPolicySuccess({ data })),
          catchError(error => of(PutPolicyFailure({ error })))
        )
      )
    )
  );

}
